import React from 'react';
import Header from '../components/Header';
import Footer from '../components/Footer';
import WhatsAppButton from '../components/WhatsAppButton';
import PageHero from '../components/common/PageHero';
import ServiceGrid from '../components/common/ServiceGrid';
import ProcessSteps from '../components/common/ProcessSteps';
import CTASection from '../components/common/CTASection';
import LogoSlider from '../components/identite-visuelle/LogoSlider';
import AvantagesSection from '../components/identite-visuelle/AvantagesSection';
import { Palette, Target, Sparkles, CheckCircle } from 'lucide-react';

const IdentiteVisuellePage = () => {
  const logos = [
    "/lovable-uploads/33d21bb5-9fb9-4d5f-bb8e-f6192dc2fa76.png",
    "/lovable-uploads/43a5584b-1334-4284-9660-b967d08e67a0.png",
    "/lovable-uploads/69217ae7-bdb6-4eb9-9ca2-a80ae2c3697e.png",
    "/lovable-uploads/968e7e11-db79-4d86-a925-ec09e38d6473.png",
    "/lovable-uploads/642a0943-096e-48b3-9d65-d89fe836b107.png",
    "/lovable-uploads/82a7153b-c6a2-4e49-ad89-6d57bcfbf33e.png",
    "/lovable-uploads/062c7ab5-d108-4f0c-a832-6d53b6d115ad.png",
    "/lovable-uploads/56a7aaa5-2a15-484f-b92e-e1ab700c5827.png",
    "/lovable-uploads/38078877-dd6a-4113-8017-24c7e08cf60c.png",
    "/lovable-uploads/b8f98249-82d9-446e-9329-5f31ebf62271.png",
    "/lovable-uploads/ffdc9e9e-d5a3-441c-800f-1f3ad804bb3e.png",
    "/lovable-uploads/334018ca-336f-45e1-9439-b2c244cc6bcf.png"
  ];

  const processSteps = [
    {
      step: "01",
      title: "Audit & Brief",
      description: "Analyse de votre marque, vos valeurs et votre secteur d'activité",
      icon: Target
    },
    {
      step: "02", 
      title: "Recherche & Inspiration",
      description: "Exploration créative et étude des tendances du marché",
      icon: Sparkles
    },
    {
      step: "03",
      title: "Création & Concepts",
      description: "Développement de plusieurs propositions créatives",
      icon: Palette
    },
    {
      step: "04",
      title: "Finalisation",
      description: "Perfectionnement et déclinaisons du concept retenu",
      icon: CheckCircle
    }
  ];

  const services = [
    {
      title: "Logo & Symbole",
      description: "Création de logos mémorables et intemporels",
      features: ["Recherche conceptuelle", "Plusieurs propositions", "Déclinaisons couleurs", "Fichiers vectoriels"]
    },
    {
      title: "Charte Graphique",
      description: "Guide complet pour une cohérence visuelle",
      features: ["Palette de couleurs", "Typographies", "Règles d'usage", "Déclinaisons"]
    },
    {
      title: "Supports Print",
      description: "Déclinaison sur tous vos supports imprimés",
      features: ["Cartes de visite", "Papeterie", "Brochures", "Signalétique"]
    },
    {
      title: "Supports Digitaux",
      description: "Adaptation pour le monde numérique",
      features: ["Favicon", "Réseaux sociaux", "Site web", "Applications"]
    }
  ];

  return (
    <div className="min-h-screen bg-white">
      <Header />
      
      <PageHero
        badge={{ icon: Palette, text: "Identité Visuelle" }}
        title='Votre <span class="font-semibold text-blue-600">identité</span>'
        subtitle="révélée par le design"
        description="Je transforme votre vision en identité visuelle forte et mémorable. Du logo à la charte graphique complète, créons ensemble l'image qui vous ressemble."
      />

      <LogoSlider logos={logos} />

      <ServiceGrid
        title='Mes <span class="font-semibold text-blue-600">services</span>'
        subtitle="Une gamme complète de services pour une identité visuelle cohérente et impactante"
        services={services}
      />

      <ProcessSteps
        title='Mon <span class="font-semibold text-blue-600">processus</span> créatif'
        subtitle="Une méthodologie éprouvée pour créer une identité qui vous ressemble"
        steps={processSteps}
      />

      <AvantagesSection />

      <CTASection
        title='Prêt à créer votre <span class="font-semibold text-blue-600">identité visuelle</span> ?'
        description="Discutons de votre projet et donnons vie à votre marque."
        primaryButtonText="Démarrer mon projet"
        whatsappMessage="Bonjour Julycia ! J'aimerais discuter d'un projet d'identité visuelle avec vous."
      />

      <Footer />
      <WhatsAppButton />
    </div>
  );
};

export default IdentiteVisuellePage;
